/* ==========================================================================
   PDPカスタム機能(元 main-product.liquid 内のインラインスクリプト)
   商品固有の値はテンプレート内の JSONアイランド #PdpData-* から受け取る
   ========================================================================== */
var __pdpDataEl = document.querySelector('script[id^="PdpData-"]');
var DATA = {};
try { DATA = __pdpDataEl ? JSON.parse(__pdpDataEl.textContent) : {}; } catch (e) { DATA = {}; }
var SID = DATA.sectionId || '';

// PDPのカスタム機能の初期化を、表示が落ち着いた後(loadイベント。最大2.5秒で保証)にまとめて実行する
window.__pdpWhenReady = function(fn) {
  var done = false;
  function run() { if (!done) { done = true; fn(); } }
  if (document.readyState === 'complete') { run(); return; }
  window.addEventListener('load', run);
  setTimeout(run, 2500);
};

                (function() {
                  var containerId = 'product-tabs-' + SID + '';
                  window.__pdpWhenReady(function() {
                    var container = document.getElementById(containerId);
                    if (!container) return;
                    var tabs = container.querySelectorAll('.product__tab');
                    var panels = container.querySelectorAll('.product__tab-panel');
                    tabs.forEach(function(tab) {
                      tab.addEventListener('click', function() {
                        var target = tab.getAttribute('data-tab');
                        tabs.forEach(function(t) { t.classList.remove('product__tab--active'); t.setAttribute('aria-selected', 'false'); });
                        panels.forEach(function(p) { p.style.display = 'none'; p.classList.remove('product__tab-panel--active'); });
                        tab.classList.add('product__tab--active');
                        tab.setAttribute('aria-selected', 'true');
                        var panel = container.querySelector('[data-panel="' + target + '"]');
                        if (panel) { panel.style.display = 'block'; panel.classList.add('product__tab-panel--active'); }
                      });
                    });
                    // 商品説明内のspecsテーブルを非表示
                    container.querySelectorAll('.js-desc-clean table, .js-desc-clean .specs-table, .js-desc-clean .read-more__overlay').forEach(function(el) {
                      el.style.display = 'none';
                    });
                    // Move shipping blocks into shipping panel, sorted by data-shipping-order
                    var shippingBlocks = Array.from(document.querySelectorAll('[data-shipping-tab="' + SID + '"]'));
                    var shippingPanel = container.querySelector('[data-panel="shipping"]');
                    if (shippingPanel && shippingBlocks.length) {
                      shippingBlocks.sort(function(a, b) {
                        return (parseInt(a.getAttribute('data-shipping-order')) || 99) - (parseInt(b.getAttribute('data-shipping-order')) || 99);
                      });
                      shippingBlocks.forEach(function(el) {
                        shippingPanel.appendChild(el);
                        el.style.display = 'block';
                      });
                      // <p>/<br>タグを改行文字に変換してwhite-space:pre-lineで表示
                      shippingPanel.querySelectorAll('.product__shipping-text').forEach(function(el) {
                        el.innerHTML = el.innerHTML
                          .replace(/<\/p>\s*<p[^>]*>/gi, '\n')
                          .replace(/<p[^>]*>/gi, '')
                          .replace(/<\/p>/gi, '')
                          .replace(/<br\s*\/?>/gi, '\n')
                          .replace(/\n{2,}/g, '\n')
                          .trim();
                      });
                      // 区切り線をコンテンツの最後に追加
                      var shippingHr = document.createElement('hr');
                      shippingHr.className = 'desc-readmore-divider';
                      shippingPanel.appendChild(shippingHr);
                    }
                  });
                  // もっと見るボタン：コンテンツが短い場合は非表示
                  (function() {
                    var preview = document.querySelector('#desc-readmore-' + SID + '')?.closest('.product__tab-panel')?.querySelector('.desc-preview');
                    var btn = document.getElementById('desc-readmore-' + SID + '');
                    if (preview && btn) {
                      var inner = preview.querySelector('.rte');
                      if (inner && inner.scrollHeight <= 224) {
                        preview.style.maxHeight = 'none';
                        preview.style.overflow = 'visible';
                        // グラデーション非表示
                        var style = document.createElement('style');
                        style.textContent = '.desc-preview::after { display: none !important; }';
                        document.head.appendChild(style);
                        btn.style.display = 'none';
                      }
                    }
                  })();

                  // もっと見るモーダル
                  var readmoreBtn = document.getElementById('desc-readmore-' + SID + '');
                  var modalOverlay = document.getElementById('desc-modal-' + SID + '');
                  if (readmoreBtn && modalOverlay) {
                    function openModal() {
                      modalOverlay.style.display = 'flex';
                      requestAnimationFrame(function() {
                        modalOverlay.classList.add('is-open');
                      });
                      document.body.style.overflow = 'hidden';
                      document.body.classList.add('desc-modal-open');
                      if (window.__setChatVisible) window.__setChatVisible(false);
                    }
                    function closeModal() {
                      modalOverlay.classList.remove('is-open');
                      setTimeout(function() { modalOverlay.style.display = 'none'; }, 350);
                      document.body.style.overflow = '';
                      document.body.classList.remove('desc-modal-open');
                      if (window.__setChatVisible) window.__setChatVisible(true);
                    }
                    readmoreBtn.addEventListener('click', openModal);
                    modalOverlay.querySelector('.desc-modal__close-x').addEventListener('click', closeModal);
                    modalOverlay.querySelector('.desc-modal__close-btn').addEventListener('click', closeModal);
                    modalOverlay.addEventListener('click', function(e) {
                      if (e.target === modalOverlay) closeModal();
                    });
                    // 下スワイプで閉じる
                    var descSheet = modalOverlay.querySelector('.desc-modal');
                    var descSwipeStartY = 0;
                    descSheet.addEventListener('touchstart', function(e) {
                      descSwipeStartY = e.touches[0].clientY;
                    }, { passive: true });
                    descSheet.addEventListener('touchend', function(e) {
                      if (e.changedTouches[0].clientY - descSwipeStartY > 80) closeModal();
                    }, { passive: true });
                  }
                })();

    (function() {
      window.__pdpWhenReady(function() {
        // バリエーションJSONを取得（なければLiquidで埋め込んだフォールバックを使用）
        var variantsScript = document.querySelector('variant-selects script[type="application/json"], variant-radios script[type="application/json"]');
        var parsedVariants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
        var variantsData = Array.isArray(parsedVariants) ? parsedVariants : (window.__productVariants || []);

        var stickyBtn = document.getElementById('sticky-cart-btn-' + SID + '');
        var stickyLabel = document.getElementById('sticky-cart-label-' + SID + '');
        var restockBtn = document.getElementById('restock-btn-' + SID + '');
        var cartButtons = document.getElementById('cart-buttons-' + SID + '');
        var soldoutTag = document.getElementById('soldout-tag-' + SID + '');
        if (!stickyBtn) return;

        // メインボタンのスピナー表示をstickyボタンに同期
        var mainSpinner = document.querySelector('#cart-fixed-button-' + SID + ' .loading-overlay__spinner');
        if (mainSpinner) {
          new MutationObserver(function() {
            var isLoading = !mainSpinner.classList.contains('hidden');
            stickyBtn.classList.toggle('is-loading', isLoading);
          }).observe(mainSpinner, { attributes: true, attributeFilter: ['class'] });
        }

        var btnObserver = null;

        // 税込テキストの位置を強制固定する関数
        function fixTaxNote() {
          var priceEl = document.getElementById('price-' + SID + '');
          if (!priceEl) return;
          var container = priceEl.querySelector('.price__container');
          if (!container) return;
          var small = container.querySelector('small');
          if (!small) return;
          small.style.setProperty('white-space', 'nowrap', 'important');
          small.style.setProperty('flex-shrink', '0', 'important');
        }

        // DawnのfetchによるDOM更新後も税込位置を保持
        (function() {
          var priceEl = document.getElementById('price-' + SID + '');
          if (!priceEl) return;
          new MutationObserver(function() {
            fixTaxNote();
          }).observe(priceEl, { childList: true, subtree: true });
        })();

        // ---- バリアント選択モーダル ----
        var hasMultipleVariants = DATA.hasOnlyDefaultVariant === false;
        var productOptionNames = DATA.options;
        var variantModal = document.getElementById('variant-modal-' + SID + '');
        var variantModalImg = document.getElementById('variant-modal-img-' + SID + '');
        var variantModalPrice = document.getElementById('variant-modal-price-' + SID + '');
        var variantModalOptions = document.getElementById('variant-modal-options-' + SID + '');
        var variantModalAddBtn = document.getElementById('variant-modal-add-' + SID + '');
        var selectedModalOpts = {};
        var currentModalVariant = null;

        function formatModalPrice(cents) {
          return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
        }

        function getModalVariant() {
          return variantsData.find(function(v) {
            return productOptionNames.every(function(opt, i) {
              return v['option' + (i + 1)] === selectedModalOpts[i];
            });
          }) || null;
        }

        function updateModalVariant() {
          currentModalVariant = getModalVariant() || (variantsData.length ? variantsData[0] : null);
          if (!currentModalVariant) return;
          if (variantModalPrice) {
            if (currentModalVariant.compare_at_price && currentModalVariant.compare_at_price > currentModalVariant.price) {
              variantModalPrice.innerHTML = formatModalPrice(currentModalVariant.price) + ' <s style="font-size:12px;color:#919191;font-weight:400;">' + formatModalPrice(currentModalVariant.compare_at_price) + '</s>';
            } else {
              variantModalPrice.textContent = formatModalPrice(currentModalVariant.price);
            }
          }
          if (variantModalImg && currentModalVariant.featured_media && currentModalVariant.featured_media.preview_image) {
            var src = currentModalVariant.featured_media.preview_image.src;
            variantModalImg.src = src.split('?')[0] + '?width=120&format=webp';
          }
          if (variantModalAddBtn) {
            variantModalAddBtn.disabled = !currentModalVariant.available;
            variantModalAddBtn.setAttribute('data-variant-id', currentModalVariant.id);
            var span = variantModalAddBtn.querySelector('span');
            if (span) span.textContent = currentModalVariant.available ? 'カートに入れる' : '売り切れ';
          }
        }

        function renderModalOptions() {
          if (!variantModalOptions) return;
          variantModalOptions.innerHTML = '';
          productOptionNames.forEach(function(optName, optIdx) {
            var vals = [];
            variantsData.forEach(function(v) {
              var val = v['option' + (optIdx + 1)];
              if (val && vals.indexOf(val) === -1) vals.push(val);
            });
            var group = document.createElement('div');
            var lbl = document.createElement('p');
            lbl.className = 'variant-modal__option-label';
            lbl.textContent = optName;
            group.appendChild(lbl);
            var wrap = document.createElement('div');
            wrap.className = 'variant-modal__option-btns';
            vals.forEach(function(val) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'variant-modal__option-btn' + (selectedModalOpts[optIdx] === val ? ' is-selected' : '');
              btn.textContent = val;
              btn.addEventListener('click', function() {
                selectedModalOpts[optIdx] = val;
                renderModalOptions();
                updateModalVariant();
              });
              wrap.appendChild(btn);
            });
            group.appendChild(wrap);
            variantModalOptions.appendChild(group);
          });
        }

        function openVariantModal() {
          var idInput = document.querySelector('#product-form-' + SID + ' input[name="id"]');
          var currentId = idInput ? parseInt(idInput.value) : null;
          var currentVar = (currentId && variantsData.find(function(v) { return v.id === currentId; })) || variantsData[0] || null;
          if (currentVar) {
            productOptionNames.forEach(function(opt, i) { selectedModalOpts[i] = currentVar['option' + (i + 1)]; });
          }
          renderModalOptions();
          updateModalVariant();
          if (variantModal) {
            variantModal.classList.add('is-open');
            variantModal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            document.body.classList.add('variant-modal-open');
          }
        }

        function closeVariantModal() {
          if (variantModal) {
            variantModal.classList.remove('is-open');
            variantModal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            document.body.classList.remove('variant-modal-open');
          }
        }

        if (variantModal) {
          var sheet = variantModal.querySelector('.variant-modal__sheet');
          var overlay = variantModal.querySelector('.variant-modal__overlay');

          // オーバーレイ直接タップで閉じる（シート外のみ）
          overlay.addEventListener('click', closeVariantModal);
          overlay.addEventListener('touchend', function(e) { e.preventDefault(); closeVariantModal(); });

          variantModal.querySelector('.variant-modal__close').addEventListener('click', closeVariantModal);

          // 下スワイプで閉じる（シートが一番上にスクロールされている時のみ）
          var swipeStartY = 0;
          sheet.addEventListener('touchstart', function(e) {
            swipeStartY = e.touches[0].clientY;
          }, { passive: true });
          sheet.addEventListener('touchend', function(e) {
            var diff = e.changedTouches[0].clientY - swipeStartY;
            if (diff > 80 && sheet.scrollTop === 0) closeVariantModal();
          }, { passive: true });
        }
        if (variantModalAddBtn) {
          variantModalAddBtn.addEventListener('click', function() {
            if (!currentModalVariant || !currentModalVariant.available) return;
            var targetId = parseInt(variantModalAddBtn.getAttribute('data-variant-id')) || currentModalVariant.id;

            var previousError = document.getElementById(
              'variant-cart-error-' + SID
            );
            if (previousError) {
              previousError.textContent = '';
              previousError.hidden = true;
            }

            variantModalAddBtn.disabled = true;

            // モーダルはfetch完了後に閉じる（先に閉じるとタッチの合成クリックが下のボタンに貫通する）
            var cartNotification =
              document.querySelector('cart-notification');

            var cartRoot =
              window.Shopify && window.Shopify.routes
                ? window.Shopify.routes.root
                : '/';

            var addPayload = {
              id: targetId,
              quantity: 1
            };

            if (
              cartNotification &&
              typeof cartNotification.getSectionsToRender === 'function'
            ) {
              addPayload.sections =
                cartNotification.getSectionsToRender().map(function(section) {
                  return section.id;
                });

              addPayload.sections_url = window.location.pathname;
            }

            fetch(cartRoot + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(addPayload)
            })

            .then(function(response) {
              return response.json().then(function(data) {
                if (!response.ok || data.status) {
                  var message =
                    typeof data.description === 'string'
                      ? data.description
                      : '商品を追加できませんでした。在庫や選択内容をご確認ください。';

                  var error = new Error(message);
                  error.isCartRejection = true;
                  throw error;
                }

                return data;
              });
            })
            .then(function(addedItem) {
              closeVariantModal();
              variantModalAddBtn.disabled = false;

              try {
                if (
                  !cartNotification ||
                  !addedItem.sections ||
                  typeof cartNotification.renderContents !== 'function'
                ) {
                  window.location.assign(cartRoot + 'cart');
                  return;
                }

                var requiredSections =
                  cartNotification.getSectionsToRender();

                var hasAllSections = requiredSections.every(function(section) {
                  return (
                    typeof addedItem.sections[section.id] === 'string' &&
                    addedItem.sections[section.id].trim() !== ''
                  );
                });

                if (!hasAllSections) {
                  window.location.assign(cartRoot + 'cart');
                  return;
                }

                if (
                  typeof cartNotification.setActiveElement === 'function'
                ) {
                  cartNotification.setActiveElement(
                    document.getElementById('cart-icon-bubble')
                  );
                }

                cartNotification.renderContents(addedItem);
              } catch (notificationError) {
                window.location.assign(cartRoot + 'cart');
              }
            })
            .catch(function(error) {
              var errorId = 'variant-cart-error-' + SID;
              var errorBox = document.getElementById(errorId);

              if (!errorBox) {
                errorBox = document.createElement('p');
                errorBox.id = errorId;
                errorBox.setAttribute('role', 'alert');
                errorBox.style.cssText =
                  'margin:12px 0 0;color:#b85350;font-size:13px;line-height:1.6;';

                variantModalAddBtn.insertAdjacentElement(
                  'afterend',
                  errorBox
                );
              }

              var message = error.isCartRejection
                ? error.message
                : '通信結果を確認できませんでした。再度追加する前に、カートの中身をご確認ください。';

              errorBox.textContent = message;

              if (
                variantModal &&
                variantModal.classList.contains('is-open')
              ) {
                errorBox.hidden = false;
              } else {
                window.alert(message);
              }

              variantModalAddBtn.disabled = false;
            });

          });
        }
        // バリアント画像を事前キャッシュ（モーダル内切り替えを高速化）
        variantsData.forEach(function(v) {
          if (v.featured_media && v.featured_media.preview_image) {
            var img = new Image();
            img.src = v.featured_media.preview_image.src.split('?')[0] + '?width=120&format=webp';
          }
        });
        // ---- モーダルここまで ----

        function applyVariantUI(variant) {
          if (!variant) return;

          // hidden input を必ず正しいIDに更新（Dawnのupdatevariantinputに頼らない）
          var idInput = document.querySelector('#product-form-' + SID + ' input[name="id"]');
          if (idInput) {
            idInput.value = variant.id;
            idInput.removeAttribute('disabled');
          }

          var cartButtonsEl = document.getElementById('cart-buttons-' + SID + '');
          var restockBtnEl = document.getElementById('restock-btn-' + SID + '');
          var soldoutTagEl = document.getElementById('soldout-tag-' + SID + '');

          // available で判断（Liquidの値が信頼できる基準）
          var isSoldout = !variant.available;
          // Liquidで埋め込んだ在庫数を使用（クライアントJSONでは取得不可なため）
          var invQtyRaw = window.__invQty ? window.__invQty[String(variant.id)] : undefined;
          var qty = (invQtyRaw !== undefined && invQtyRaw !== null) ? invQtyRaw : -1;
          // inventory_policy: continue の場合、availableがtrueでも在庫0なら売り切れ扱い
          if (!isSoldout && qty === 0) { isSoldout = true; }
          var isLowStock = !isSoldout && qty > 0 && qty <= 3;

          // 前回のMutationObserverをクリア
          if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }

          // 売り切れタグ
          if (soldoutTagEl) soldoutTagEl.classList.toggle('is-visible', isSoldout);

          // 数量セレクトの上限を在庫数に合わせる（同じIDが複数ある場合も全て更新）
          var maxQty = (qty > 0) ? Math.min(qty, 10) : 1;
          document.querySelectorAll('select[name="quantity"], input[name="quantity"]').forEach(function(el) {
            if (el.tagName === 'SELECT') {
              var currentVal = parseInt(el.value) || 1;
              el.innerHTML = '';
              for (var q = 1; q <= maxQty; q++) {
                var opt = document.createElement('option');
                opt.value = q; opt.textContent = q;
                if (q === Math.min(currentVal, maxQty)) opt.selected = true;
                el.appendChild(opt);
              }
            } else {
              el.setAttribute('max', maxQty);
              if (parseInt(el.value) > maxQty) el.value = maxQty;
            }
          });

          // 残在庫タグ
          var stockTag = document.getElementById('stock-tag-' + SID + '');
          if (stockTag) {
            if (isLowStock) {
              stockTag.textContent = '残り' + qty + '個';
              stockTag.style.display = 'inline-block';
            } else {
              stockTag.style.display = 'none';
            }
          }

          // メインエリア
          if (cartButtonsEl) {
            cartButtonsEl.classList.toggle('is-hidden', isSoldout);
            cartButtonsEl.classList.toggle('is-available', !isSoldout);
          }
          if (restockBtnEl) restockBtnEl.classList.toggle('is-visible', isSoldout);

          // 在庫あり → submitボタンのdisabledをMutationObserverで即座に解除（Dawnの一時的disable対策）
          if (!isSoldout) {
            var submitBtn = document.querySelector('#cart-fixed-button-' + SID + ' button[type=submit]');
            if (submitBtn) {
              submitBtn.removeAttribute('disabled');
              btnObserver = new MutationObserver(function() {
                if (submitBtn.hasAttribute('disabled')) submitBtn.removeAttribute('disabled');
              });
              btnObserver.observe(submitBtn, { attributes: true, attributeFilter: ['disabled'] });
              setTimeout(function() {
                if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }
              }, 800);
            }
          }

          // 価格更新
          var priceEl = document.getElementById('price-' + SID + '');
          if (priceEl && variant.price !== undefined) {
            var formatPrice = function(cents) {
              return '&yen;' + Math.floor(cents / 100).toLocaleString('ja-JP');
            };
            var regularPriceEl = priceEl.querySelector('.price__regular .price-item--regular');
            var salePriceEl = priceEl.querySelector('.price__sale .price-item--sale');
            var compareEl = priceEl.querySelector('.price__sale .price-item--regular');
            // Liquidと同じ内側の価格要素でセール状態を管理する。
            // 外側に残った旧処理の状態も解除し、通常価格への切り替えを妨げない。
            var priceStateEl = priceEl.querySelector('.price') || priceEl;
            priceEl.classList.remove('price--on-sale');
            priceStateEl.classList.toggle('price--on-sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              if (salePriceEl) salePriceEl.innerHTML = formatPrice(variant.price) + '<span class="visually-hidden"> 税込</span>';
              if (compareEl) compareEl.innerHTML = formatPrice(variant.compare_at_price);
            } else {
              priceEl.classList.remove('price--on-sale');
              if (regularPriceEl) regularPriceEl.innerHTML = formatPrice(variant.price) + '<span class="visually-hidden"> 税込</span>';
            }
            // 税込の位置を強制固定
            fixTaxNote();
          }

          // 画像更新（スライダーを直接操作）
          if (variant.featured_media) {
            var targetMediaId = SID + '-' + variant.featured_media.id;
            var slider = document.querySelector('#GalleryViewer-' + SID + ' .slider');
            var targetSlide = document.querySelector('[data-media-id="' + targetMediaId + '"]');
            if (slider && targetSlide) {
              slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
              slider.querySelectorAll('.slider__slide').forEach(function(s) { s.classList.remove('is-active'); });
              targetSlide.classList.add('is-active');
            }
          }

          // stickyボタン
          var stickyIcon = stickyBtn.querySelector('svg');
          var cartIconSVG = '<path d="M4.62 9.96h10.72l6.37 27.89h27.98l6.48-21.5-39.5-.56M51.73 44.35H21.67a3.21 3.21 0 01-3.28-3.28c0-3.22 3.32-3.22 3.32-3.22"/><circle cx="24.95" cy="51.61" r="3.53"/><circle cx="46.04" cy="51.61" r="3.53"/>';
          var bellIconSVG = '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>';
          if (isSoldout) {
            stickyBtn.classList.add('is-soldout');
            stickyBtn.removeAttribute('disabled');
            stickyLabel.textContent = '再入荷通知を受け取る';
            if (stickyIcon) { stickyIcon.setAttribute('viewBox', '0 0 24 24'); stickyIcon.innerHTML = bellIconSVG; }
            stickyBtn.onclick = function() { var el = document.querySelector('.email-me-button'); if (el) el.click(); };
          } else {
            stickyBtn.classList.remove('is-soldout');
            stickyLabel.textContent = 'カートに入れる';
            if (stickyIcon) { stickyIcon.setAttribute('viewBox', '0 0 64 64'); stickyIcon.innerHTML = cartIconSVG; }
            stickyBtn.onclick = function() {
              if (hasMultipleVariants && variantModal) { openVariantModal(); }
              else { document.querySelector('#cart-fixed-button-' + SID + ' button[type=submit]').click(); }
            };
          }
        }

        // changeイベントでselect/radioの選択値を直接読んでJSONとマッチング
        // Dawn処理のタイミングやエラーに依存しない
        document.addEventListener('change', function(e) {
          var container = e.target.closest('variant-selects, variant-radios');
          if (!container) return;

          var selectedOptions = [];
          container.querySelectorAll('select').forEach(function(sel) {
            selectedOptions.push(sel.value);
          });
          container.querySelectorAll('input[type="radio"]:checked').forEach(function(radio) {
            selectedOptions.push(radio.value);
          });
          if (selectedOptions.length === 0) return;

          var variant = variantsData.find(function(v) {
            return selectedOptions.every(function(val, i) {
              return v['option' + (i + 1)] === val;
            });
          });
          applyVariantUI(variant);
        });

        // variant:changeが発火する環境の保険
        document.addEventListener('variant:change', function(e) {
          var detail = e.detail && e.detail.variant;
          if (detail && detail.id) {
            applyVariantUI(variantsData.find(function(v) { return v.id === detail.id; }));
          }
        });

        // DawnのvariantStringsを上書きしてカートボタンのテキストを固定
        (function fixCartBtnText() {
          // variantStrings が既に存在する場合は即上書き
          if (window.variantStrings) {
            window.variantStrings.addToCart = 'カートに入れる';
          }
          // 後から設定された場合も捕捉
          var _vs = window.variantStrings;
          Object.defineProperty(window, 'variantStrings', {
            get: function() { return _vs; },
            set: function(v) {
              if (v) v.addToCart = 'カートに入れる';
              _vs = v;
            },
            configurable: true
          });
          // 念のため：ボタンのspanをMutationObserverで監視（DOMが丸ごと置き換わる場合の保険）
          var container = document.getElementById('cart-fixed-button-' + SID + '');
          if (!container) return;
          var btnObs = new MutationObserver(function() {
            var btn = container.querySelector('button[type=submit]');
            if (!btn || btn.disabled) return;
            var span = btn.querySelector('span:not(.visually-hidden):not(.loading-overlay__spinner)');
            if (span && span.textContent.trim() && span.textContent.trim() !== 'カートに入れる') {
              span.textContent = 'カートに入れる';
            }
          });
          btnObs.observe(container, { childList: true, subtree: true, characterData: true });
        })();

        // input[name="id"]のdisabledを解除（disabledのままだとFormDataに含まれずデフォルト variant が送信される）
        (function() {
          var idInput = document.querySelector('#product-form-' + SID + ' input[name="id"]');
          if (idInput) idInput.removeAttribute('disabled');
        })();

        // 初回：URLまたはhidden inputから取得
        (function() {
          var urlParams = new URLSearchParams(window.location.search);
          var initialId = parseInt(urlParams.get('variant'));
          if (!initialId) {
            var idInput = document.querySelector('#product-form-' + SID + ' input[name="id"]');
            initialId = idInput ? parseInt(idInput.value) : null;
          }
          applyVariantUI(variantsData.find(function(v) { return v.id === initialId; }));
        })();
      });
    })();

    // ARボタン：XRが利用可能な商品だけstickyバーに表示
    window.__pdpWhenReady(function() {
      var origArBtn = document.querySelector('.product__xr-button[data-shopify-xr]');
      var stickyArBtn = document.getElementById('sticky-ar-btn-' + SID + '');
      if (!origArBtn || !stickyArBtn) return;

      function syncArBtn() {
        var available = !origArBtn.hasAttribute('data-shopify-xr-hidden');
        stickyArBtn.style.display = available ? 'flex' : 'none';
      }

      // Shopifyがdata-shopify-xr-hidden属性を変更したら同期
      new MutationObserver(syncArBtn).observe(origArBtn, { attributes: true, attributeFilter: ['data-shopify-xr-hidden'] });
      syncArBtn();

      stickyArBtn.addEventListener('click', function() { origArBtn.click(); });
    });

    window.__pdpWhenReady(function() {




      // お届け予定日計算
      (function() {
        var prefSelect = document.getElementById('delivery-pref-' + SID + '');
        var dateSpan = document.getElementById('delivery-date-' + SID + '');
        if (!prefSelect || !dateSpan) return;

        var holidays = [
          '2026-01-01','2026-01-12','2026-02-11','2026-02-23','2026-03-20',
          '2026-04-29','2026-05-03','2026-05-04','2026-05-05','2026-05-06',
          '2026-07-20','2026-08-11','2026-09-21','2026-09-22','2026-09-23',
          '2026-10-12','2026-11-03','2026-11-23',
          '2027-01-01','2027-01-11','2027-02-11','2027-02-23','2027-03-21',
          '2027-04-29','2027-05-03','2027-05-04','2027-05-05',
          '2027-07-19','2027-08-11','2027-09-20','2027-09-23',
          '2027-10-11','2027-11-03','2027-11-23'
        ];
        var DOW = ['日','月','火','水','木','金','土'];

        function toJST(d) {
          return new Date(d.getTime() + (d.getTimezoneOffset() + 540) * 60000);
        }
        function dateKey(d) {
          return d.getFullYear() + '-' +
            String(d.getMonth()+1).padStart(2,'0') + '-' +
            String(d.getDate()).padStart(2,'0');
        }
        function isHoliday(d) {
          var dow = d.getDay();
          return dow === 0 || dow === 6 || holidays.indexOf(dateKey(d)) !== -1;
        }
        function addDays(d, n) {
          var r = new Date(d); r.setDate(r.getDate() + n); return r;
        }
        function nextBizDay(d) {
          var r = addDays(d, 1);
          while (isHoliday(r)) r = addDays(r, 1);
          return r;
        }
        function formatDate(d) {
          return (d.getMonth()+1) + '月' + d.getDate() + '日（' + DOW[d.getDay()] + '）';
        }
        function formatDateShort(d) {
          return d.getDate() + '日（' + DOW[d.getDay()] + '）';
        }
        function calcDelivery(minDays, maxDays) {
          var now = toJST(new Date());
          var h = now.getHours(), m = now.getMinutes();
          var beforeCutoff = h < 9 || (h === 9 && m < 50);
          var shipDate = (!isHoliday(now) && beforeCutoff) ? now : nextBizDay(now);
          var minDate = addDays(shipDate, minDays);
          var text = formatDate(minDate);
          if (maxDays && maxDays !== minDays) {
            var maxDate = addDays(shipDate, maxDays);
            // 同月なら「~8日（木）」、別月なら「~11月1日（日）」
            var shortMax = minDate.getMonth() === maxDate.getMonth()
              ? '~' + formatDateShort(maxDate)
              : '~' + formatDate(maxDate);
            text += shortMax;
          }
          return text;
        }
        function parseAndCalc(val) {
          var parts = val.split('-');
          return calcDelivery(parseInt(parts[0]), parts[1] ? parseInt(parts[1]) : null);
        }

        // 初期表示
        dateSpan.innerHTML = calcDelivery(1, null);

        prefSelect.addEventListener('change', function() {
          dateSpan.innerHTML = prefSelect.value ? parseAndCalc(prefSelect.value) : calcDelivery(1, null);
          syncSelectWidth();
        });
      })();

    });

    // 画像モーダル：閉じるボタンを画像右上に位置合わせ
    (function() {
      function positionModalCloseBtn() {
        var modal = document.getElementById('ProductModal-' + SID + '');
        if (!modal || !modal.hasAttribute('open')) return;
        var toggle = modal.querySelector('.product-media-modal__toggle');
        if (!toggle) return;
        // 画像要素を複数の方法で探す
        var activeImg = modal.querySelector('[data-media-id].active img')
                     || modal.querySelector('.product-media-modal__content img')
                     || modal.querySelector('[data-media-id].active');
        if (!activeImg) return;
        var rect = activeImg.getBoundingClientRect();
        // 画像上端より少し上（8px上）に配置
        toggle.style.top = Math.max(8, rect.top - 36) + 'px';
        toggle.style.right = (window.innerWidth - rect.right + 8) + 'px';
        toggle.style.left = 'auto';
      }

      // 画像モーダル：自前スライドビュー（指の動きに追従）
      (function() {
        var modal = document.getElementById('ProductModal-' + SID + '');
        if (!modal) return;

  var slideUrls = DATA.imageUrls1200;
        var slideView = null, track = null, currentIdx = 0;
        var touchStartX = 0, touchStartY = 0, isDragging = false;
        var GAP = 12;

        function getOffset(idx) {
          return -(idx * (window.innerWidth + GAP));
        }

        function buildSlideView(startIdx) {
          // 既存削除
          if (slideView) slideView.remove();

          slideView = document.createElement('div');
          slideView.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:9998;overflow:hidden;display:flex;align-items:flex-start;padding-top:8vh;box-sizing:border-box;pointer-events:auto;';

          track = document.createElement('div');
          track.style.cssText = 'display:flex;gap:' + GAP + 'px;height:70vh;will-change:transform;flex-shrink:0;';

          slideUrls.forEach(function(url) {
            var slide = document.createElement('div');
            slide.style.cssText = 'flex-shrink:0;width:100vw;height:100%;display:flex;align-items:center;justify-content:center;';
            var img = document.createElement('img');
            img.src = url;
            img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;display:block;';
            slide.appendChild(img);
            track.appendChild(slide);
          });

          slideView.appendChild(track);
          modal.querySelector('.product-media-modal__dialog').appendChild(slideView);

          // Dawnのオリジナルコンテンツを非表示
          var origContent = modal.querySelector('.product-media-modal__content');
          if (origContent) origContent.style.visibility = 'hidden';

          currentIdx = startIdx;
          track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)';

          // タッチイベント（スライドビュー上）
          slideView.addEventListener('touchstart', function(e) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            isDragging = false;
            track.style.transition = 'none';
          }, { passive: true });

          slideView.addEventListener('touchmove', function(e) {
            var dx = e.touches[0].clientX - touchStartX;
            var dy = e.touches[0].clientY - touchStartY;
            if (!isDragging && Math.abs(dy) > Math.abs(dx)) return;
            isDragging = true;
            track.style.transform = 'translateX(' + (getOffset(currentIdx) + dx) + 'px)';
          }, { passive: true });

          slideView.addEventListener('touchend', function(e) {
            var dx = e.changedTouches[0].clientX - touchStartX;
            track.style.transition = 'transform 0.3s ease';
            if (dx < -40 && currentIdx < slideUrls.length - 1) currentIdx++;
            else if (dx > 40 && currentIdx > 0) currentIdx--;
            track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)';
          }, { passive: true });

          // PC：マウスドラッグで画像切り替え
          var mouseStartX = 0, mouseDown = false;
          slideView.addEventListener('mousedown', function(e) {
            mouseStartX = e.clientX;
            mouseDown = true;
            track.style.transition = 'none';
            e.preventDefault();
          });
          window.addEventListener('mousemove', function(e) {
            if (!mouseDown) return;
            track.style.transform = 'translateX(' + (getOffset(currentIdx) + e.clientX - mouseStartX) + 'px)';
          });
          window.addEventListener('mouseup', function(e) {
            if (!mouseDown) return;
            mouseDown = false;
            var dx = e.clientX - mouseStartX;
            track.style.transition = 'transform 0.3s ease';
            if (dx < -50 && currentIdx < slideUrls.length - 1) currentIdx++;
            else if (dx > 50 && currentIdx > 0) currentIdx--;
            track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)';
          });

          // PC：マウスホイールで画像切り替え（documentレベルでキャプチャ）
          slideView._wheelHandler = function(e) {
            if (!modal.hasAttribute('open') || !slideView) return;
            e.preventDefault();
            e.stopPropagation();
            track.style.transition = 'transform 0.3s ease';
            if (e.deltaY > 0 || e.deltaX > 0) {
              if (currentIdx < slideUrls.length - 1) currentIdx++;
            } else {
              if (currentIdx > 0) currentIdx--;
            }
            track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)';
          };
          document.addEventListener('wheel', slideView._wheelHandler, { passive: false, capture: true });

          // PC：キーボード矢印キーで画像切り替え
          slideView._keyHandler = function(e) {
            if (!modal.hasAttribute('open')) return;
            track.style.transition = 'transform 0.3s ease';
            if ((e.key === 'ArrowRight' || e.key === 'ArrowDown') && currentIdx < slideUrls.length - 1) {
              currentIdx++;
              track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)';
            } else if ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') && currentIdx > 0) {
              currentIdx--;
              track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)';
            }
          };
          document.addEventListener('keydown', slideView._keyHandler);

          // 前後ボタン
          if (slideUrls.length > 1) {
            var btnStyle = 'position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.15);border:none;color:#fff;font-size:2rem;width:48px;height:48px;cursor:pointer;z-index:10;border-radius:50%;display:flex;align-items:center;justify-content:center;';
            var prevBtn = document.createElement('button');
            prevBtn.innerHTML = '&#8249;';
            prevBtn.style.cssText = btnStyle + 'left:12px;';
            prevBtn.addEventListener('click', function() {
              if (currentIdx > 0) { currentIdx--; track.style.transition = 'transform 0.3s ease'; track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)'; }
            });
            var nextBtn = document.createElement('button');
            nextBtn.innerHTML = '&#8250;';
            nextBtn.style.cssText = btnStyle + 'right:12px;';
            nextBtn.addEventListener('click', function() {
              if (currentIdx < slideUrls.length - 1) { currentIdx++; track.style.transition = 'transform 0.3s ease'; track.style.transform = 'translateX(' + getOffset(currentIdx) + 'px)'; }
            });
            slideView.appendChild(prevBtn);
            slideView.appendChild(nextBtn);
          }
        }

        // モーダルが開いたときにスライドビューを構築
        new MutationObserver(function() {
          if (modal.hasAttribute('open')) {
            // アクティブな画像のインデックスを特定
            var activeEl = modal.querySelector('[data-media-id].active img');
            var activeSrc = activeEl ? activeEl.src : '';
            var startIdx = 0;
            slideUrls.forEach(function(url, i) {
              if (activeSrc.indexOf(url.split('?')[0].split('/').pop().split('.')[0]) !== -1) startIdx = i;
            });
            setTimeout(function() { buildSlideView(startIdx); }, 50);
          } else {
            if (slideView) {
              if (slideView._keyHandler) document.removeEventListener('keydown', slideView._keyHandler);
              if (slideView._wheelHandler) document.removeEventListener('wheel', slideView._wheelHandler, { capture: true });
              slideView.remove();
              slideView = null;
            }
            // オリジナルコンテンツを再表示
            var origContent = modal.querySelector('.product-media-modal__content');
            if (origContent) origContent.style.visibility = '';
          }
        }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      })();

      // Paidyウィジェット有無で価格の余白を調整
      (function() {
        function checkPaidy() {
          var priceEl = document.getElementById('price-' + SID + '');
          if (!priceEl) return;
          // Paidyウィジェット（paidy-widget, .paidy-checkout等）を探す
          var hasPaidy = document.querySelector('paidy-widget, [data-paidy], .paidy-checkout, paidyplus-widget, [class*="paidy"]');
          priceEl.classList.toggle('has-paidy', !!hasPaidy);
          document.body.classList.toggle('page-has-paidy', !!hasPaidy);
        }
        // DOMContentLoaded後とさらに少し待って確認（アプリの遅延挿入を考慮）
        checkPaidy();
        setTimeout(checkPaidy, 800);
      })();

      // モーダルのopen属性変化を監視
      var modal = document.getElementById('ProductModal-' + SID + '');
      if (modal) {
        // 全商品画像をプリロード（スワイプ時のカクつき防止）
  var _preloadUrls = DATA.imageUrls1200;
        var _preloaded = false;

        var observer = new MutationObserver(function() {
          if (modal.hasAttribute('open')) {
            requestAnimationFrame(function() {
              setTimeout(positionModalCloseBtn, 150);
            });
            // 初回オープン時に全画像プリロード
            if (!_preloaded) {
              _preloaded = true;
              _preloadUrls.forEach(function(url) {
                var img = new Image();
                img.src = url;
              });
            }
          }
        });
        observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

        // モーダル開閉でチャットボタンを非表示/再表示
        var chatObserver = new MutationObserver(function() {
          var isOpen = modal.hasAttribute('open');
          // よくあるチャットウィジェットのセレクター
          var chatBtns = document.querySelectorAll(
            '#infobox-btn, .infobox-btn, [id*="infobox"], [class*="infobox"], ' +
            '#tidio-chat, .tidio-chat, #chat-widget, .chat-widget, ' +
            '[id*="chat-button"], [class*="chat-button"], ' +
            'iframe[id*="chat"], iframe[title*="chat"], iframe[title*="Chat"]'
          );
          chatBtns.forEach(function(el) {
            el.style.display = isOpen ? 'none' : '';
          });
        });
        chatObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
      }
    })();

    // 画像モーダル：背景タップで閉じる
    (function() {
      document.addEventListener('click', function(e) {
        var modal = document.getElementById('ProductModal-' + SID + '');
        if (!modal || !modal.hasAttribute('open')) return;
        var dialog = modal.querySelector('.product-media-modal__dialog');
        var content = modal.querySelector('.product-media-modal__content');
        var toggle = modal.querySelector('.product-media-modal__toggle');
        // コンテンツ外・トグルボタン外のクリックなら閉じる
        // モーダル内部のクリックのみ判定（opener等モーダル外クリックは無視）
        if (dialog && modal.contains(e.target) && !content.contains(e.target) && !toggle.contains(e.target)) {
          modal.hide();
        }
      });
    })();


window.__pdpWhenReady(function() {
  const slider = document.querySelector('#GalleryViewer-' + SID + ' .slider');
  const container = document.getElementById('imgDots');
  const counter = document.getElementById('imgCounter');
  if (!slider || !container) return;

  const total = slider.querySelectorAll('.slider__slide').length;
  const shown = Math.min(total, 5);

  container.innerHTML = '';
  const dots = [];
  for (let i = 0; i < shown; i++) {
    const d = document.createElement('span');
    d.className = 'product-img-dot';
    container.appendChild(d);
    dots.push(d);
  }

  function getSlideWidth() {
    const slide = slider.querySelector('.slider__slide');
    return slide ? slide.offsetWidth : slider.offsetWidth;
  }

  const gallerySlides = slider.querySelectorAll('.slider__slide');

  function getCurrentIndex() {
    const slideWidth = getSlideWidth();
    return Math.min(Math.round(slider.scrollLeft / slideWidth), total - 1);
  }

  function update() {
    const slideWidth = getSlideWidth();
    const scrollPos = slider.scrollLeft;
    const floatIdx = Math.min(scrollPos / slideWidth, total - 1);

    const cur = Math.min(Math.round(floatIdx), total - 1);

    // 全ドットに均等マッピング（各ドット間が同じスクロール数で遷移）
    const dotFloat = total > 1 ? floatIdx / (total - 1) * (shown - 1) : 0;
    const fromDot = Math.min(Math.floor(dotFloat), shown - 1);
    const toDot = Math.min(fromDot + 1, shown - 1);
    const progress = dotFloat - fromDot; // 0〜1

    dots.forEach((dot, i) => {
      dot.className = 'product-img-dot';
      dot.style.width = '';
      dot.style.background = '';

      if (i === fromDot) {
        const w = Math.round(20 - 14 * progress);
        dot.style.width = w + 'px';
        dot.style.background = '#2C3E50';
      } else if (i === toDot && fromDot !== toDot) {
        const w = Math.round(6 + 14 * progress);
        dot.style.width = w + 'px';
        dot.style.background = '#2C3E50';
      }
    });

    if (counter) counter.textContent = (cur + 1) + ' / ' + total;

    // Dawnの is-active クラスを同期（モーダルがこれを参照するため）
    gallerySlides.forEach(function(slide, i) {
      slide.classList.toggle('is-active', i === cur);
    });
  }

  slider.addEventListener('scroll', update);
  update();

  // PC：前後矢印ボタン
  (function() {
    var galleryViewer = document.getElementById('GalleryViewer-' + SID + '');
    if (!galleryViewer) return;
    galleryViewer.style.position = 'relative';

    function goTo(dir) {
      var slides = Array.from(slider.querySelectorAll('.slider__slide'));
      if (!slides.length) return;
      // is-activeクラスで現在のスライドを特定
      var curIdx = 0;
      slides.forEach(function(s, i) { if (s.classList.contains('is-active')) curIdx = i; });
      var newIdx = Math.max(0, Math.min(slides.length - 1, curIdx + dir));
      var targetSlide = slides[newIdx];
      var mediaId = targetSlide.getAttribute('data-media-id');

      // DawnのmediaGallery APIを使う
      var mediaGallery = document.querySelector('media-gallery');
      if (mediaGallery && mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(mediaId, false);
        return;
      }
      // fallback: サムネイルをクリック
      var thumb = document.querySelector('#GalleryThumbnails-' + SID + ' [data-media-id="' + mediaId + '"]');
      if (thumb) { thumb.click(); return; }
      // fallback2: スライドを直接scrollIntoView
      targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    var btnStyle = 'display:none;position:absolute;top:50%;transform:translateY(-50%);z-index:200;pointer-events:auto;background:rgba(255,255,255,0.85);border:none;cursor:pointer;width:40px;height:40px;border-radius:50%;font-size:20px;box-shadow:0 1px 6px rgba(0,0,0,0.15);align-items:center;justify-content:center;';
    var prevBtn = document.createElement('button');
    prevBtn.id = 'gallery-prev-btn';
    prevBtn.innerHTML = '&#8249;';
    prevBtn.style.cssText = btnStyle + 'left:10px;';
    prevBtn.addEventListener('click', function(e) { e.stopPropagation(); e.stopImmediatePropagation(); goTo(-1); });

    var nextBtn = document.createElement('button');
    nextBtn.id = 'gallery-next-btn';
    nextBtn.innerHTML = '&#8250;';
    nextBtn.style.cssText = btnStyle + 'right:10px;';
    nextBtn.addEventListener('click', function(e) { e.stopPropagation(); e.stopImmediatePropagation(); goTo(1); });

    galleryViewer.appendChild(prevBtn);
    galleryViewer.appendChild(nextBtn);

    // PCのみ表示
    function updateBtnVisibility() {
      var isPC = window.innerWidth >= 750;
      var slides = slider.querySelectorAll('.slider__slide').length;
      prevBtn.style.display = (isPC && slides > 1) ? 'flex' : 'none';
      nextBtn.style.display = (isPC && slides > 1) ? 'flex' : 'none';
    }
    updateBtnVisibility();
    window.addEventListener('resize', updateBtnVisibility);
  })();

  // PC：ホイールで横スクロール・マウスドラッグ対応
  slider.addEventListener('wheel', function(e) {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    e.preventDefault();
    var slides = slider.querySelectorAll('.slider__slide');
    if (!slides.length) return;
    var slideW = slides[0].offsetWidth;
    var curIdx = Math.round(slider.scrollLeft / slideW);
    var newIdx = Math.max(0, Math.min(slides.length - 1, curIdx + (e.deltaY > 0 ? 1 : -1)));
    slider.scrollTo({ left: newIdx * slideW, behavior: 'smooth' });
  }, { passive: false });

  var pcDragStartX = 0, pcDragScrollLeft = 0, pcDragging = false;
  slider.addEventListener('mousedown', function(e) {
    pcDragging = true;
    pcDragStartX = e.clientX;
    pcDragScrollLeft = slider.scrollLeft;
    slider.style.cursor = 'grabbing';
    e.preventDefault();
  });
  window.addEventListener('mousemove', function(e) {
    if (!pcDragging) return;
    slider.scrollLeft = pcDragScrollLeft - (e.clientX - pcDragStartX);
  });
  window.addEventListener('mouseup', function() {
    if (!pcDragging) return;
    pcDragging = false;
    slider.style.cursor = '';
  });

  // 独自フルスクリーンビューア（Dawnのモーダルを使わず自前で実装）
  (function() {
    var galleryViewer = document.getElementById('GalleryViewer-' + SID + '');
    if (!galleryViewer) return;

    // ビューア本体を作成
    var viewer = document.createElement('div');
    viewer.id = 'custom-img-viewer';
    viewer.style.cssText = 'display:none;position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,0.6);touch-action:pan-y pinch-zoom;';
    viewer.innerHTML = '<button id="civ-close" style="position:fixed;top:calc(15vh);right:12px;z-index:10001;background:rgba(0,0,0,0.55);color:#fff;border:none;font-size:12px;padding:6px 12px;border-radius:4px;cursor:pointer;">閉じる</button><div id="civ-track" style="display:flex;height:100%;will-change:transform;"></div>';
    document.body.appendChild(viewer);

    var track = document.getElementById('civ-track');
    var viewerOpen = false;
    var viewerIdx = 0;

    // ギャラリーの画像URLと枚数を収集
    function buildViewer() {
      track.innerHTML = '';
      gallerySlides.forEach(function(slide) {
        var img = slide.querySelector('img');
        // すでに読み込み済みのsrcをまず使う（即表示）
        var currentSrc = img ? (img.currentSrc || img.src) : '';
        // 高解像度版URLも取得
        var bestSrc = currentSrc;
        if (img && img.srcset) {
          var parts = img.srcset.split(',').map(function(s) { return s.trim().split(' '); });
          var best = parts.reduce(function(a, b) { return (parseInt(b[1]) > parseInt(a[1])) ? b : a; }, ['', '0']);
          if (best[0]) bestSrc = best[0];
        }
        var cell = document.createElement('div');
        cell.style.cssText = 'flex-shrink:0;width:94vw;height:100%;display:flex;align-items:center;justify-content:center;margin-right:12px;';
        var el = document.createElement('img');
        // まずキャッシュ済みのsrcで即表示、その後高解像度に差し替え
        el.src = currentSrc;
        el.style.cssText = 'max-width:100%;max-height:90%;object-fit:contain;border-radius:4px;';
        if (bestSrc && bestSrc !== currentSrc) {
          var hiRes = new Image();
          hiRes.onload = function() { el.src = bestSrc; };
          hiRes.src = bestSrc;
        }
        cell.appendChild(el);
        track.appendChild(cell);
      });
    }

    var CELL_VW = 94;
    var CELL_GAP = 12;

    function getOffset(idx) {
      var cellW = window.innerWidth * CELL_VW / 100;
      return idx * (cellW + CELL_GAP);
    }

    // ページ読み込み時に一度だけビューア構築（タップ時の遅延をなくす）
    buildViewer();

    // チャットホスト要素を一度だけ見つけてキャッシュ
    var _chatHosts = null;
    function getChatHosts() {
      if (_chatHosts) return _chatHosts;
      var hosts = [];
      // 通常DOM
      document.querySelectorAll('button.activator, button.activator--inverted-colors').forEach(function(el) { hosts.push(el); });
      // shadow DOM host
      document.querySelectorAll('*').forEach(function(el) {
        if (el.shadowRoot && el.shadowRoot.querySelector('.activator')) hosts.push(el);
      });
      if (hosts.length) _chatHosts = hosts;
      return hosts;
    }

    function setChatVisible(visible) {
      getChatHosts().forEach(function(el) {
        if (visible) {
          el.style.removeProperty('visibility');
          el.style.removeProperty('pointer-events');
        } else {
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
        }
      });
    }
    // 説明モーダルなど他の場所からも使えるようにグローバルに公開
    window.__setChatVisible = setChatVisible;

    function showViewer(idx) {
      viewerIdx = Math.max(0, Math.min(idx, gallerySlides.length - 1));
      track.style.transition = 'none';
      track.style.transform = 'translateX(-' + getOffset(viewerIdx) + 'px)';
      viewer.style.display = 'block';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('img-viewer-open');
      setChatVisible(false);
      viewerOpen = true;
    }

    function closeViewer() {
      viewer.style.display = 'none';
      document.body.style.overflow = '';
      document.body.classList.remove('img-viewer-open');
      setChatVisible(true);
      viewerOpen = false;
    }

    document.getElementById('civ-close').addEventListener('click', closeViewer);
    // 画像外（セルの余白 or viewer背景）タップで閉じる
    track.addEventListener('click', function(e) {
      if (e.target.tagName !== 'IMG') closeViewer();
    });
    viewer.addEventListener('click', function(e) { if (e.target === viewer) closeViewer(); });

    // スワイプ対応（タッチ）
    var touchStartX = 0;
    viewer.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    viewer.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) < 40) return;
      viewerIdx = dx < 0 ? Math.min(viewerIdx + 1, gallerySlides.length - 1) : Math.max(viewerIdx - 1, 0);
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(-' + getOffset(viewerIdx) + 'px)';
    });

    // PC：マウスドラッグ対応
    var mouseStartX = 0, mouseDown = false;
    viewer.addEventListener('mousedown', function(e) {
      if (e.target.tagName === 'BUTTON') return;
      mouseStartX = e.clientX;
      mouseDown = true;
      track.style.transition = 'none';
      e.preventDefault();
    });
    window.addEventListener('mousemove', function(e) {
      if (!mouseDown || !viewerOpen) return;
      track.style.transform = 'translateX(-' + (getOffset(viewerIdx) - (e.clientX - mouseStartX)) + 'px)';
    });
    window.addEventListener('mouseup', function(e) {
      if (!mouseDown || !viewerOpen) return;
      mouseDown = false;
      var dx = e.clientX - mouseStartX;
      if (Math.abs(dx) < 20) return; // クリックとして処理
      viewerIdx = dx < 0 ? Math.min(viewerIdx + 1, gallerySlides.length - 1) : Math.max(viewerIdx - 1, 0);
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(-' + getOffset(viewerIdx) + 'px)';
    });

    // PC：キーボード矢印キー対応
    document.addEventListener('keydown', function(e) {
      if (!viewerOpen) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        viewerIdx = Math.min(viewerIdx + 1, gallerySlides.length - 1);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        viewerIdx = Math.max(viewerIdx - 1, 0);
      } else if (e.key === 'Escape') {
        closeViewer(); return;
      } else { return; }
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(-' + getOffset(viewerIdx) + 'px)';
    });

    // ギャラリーのズームボタンをキャプチャして独自ビューアに差し替え
    galleryViewer.addEventListener('click', function(e) {
      if (e.target.closest('#gallery-prev-btn, #gallery-next-btn')) return;
      var btn = e.target.closest('.product__media-toggle');
      if (!btn) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      showViewer(getCurrentIndex());
    }, true);
  })();

  // 画像一覧モーダル
  const modal = document.createElement('div');
  modal.className = 'img-all-modal';
  modal.innerHTML = `
    <button class="img-all-close">✕</button>
    <div class="img-all-grid"></div>
  `;
  document.body.appendChild(modal);

  const grid = modal.querySelector('.img-all-grid');
  slider.querySelectorAll('.slider__slide').forEach((slide, i) => {
    const img = slide.querySelector('img');
    if (!img) return;
    const el = document.createElement('img');
    el.src = img.src;
    el.addEventListener('click', () => {
      modal.classList.remove('open');
      slider.scrollTo({ left: i * getSlideWidth(), behavior: 'smooth' });
    });
    grid.appendChild(el);
  });

  if (counter) {
    counter.style.cursor = 'pointer';
    counter.addEventListener('click', () => {
      modal.classList.add('open');
      document.body.classList.add('img-all-open');
    });
  }

  modal.querySelector('.img-all-close').addEventListener('click', () => {
    modal.classList.remove('open');
    document.body.classList.remove('img-all-open');
  });
  modal.addEventListener('click', (e) => {
    if (!e.target.closest('.img-all-grid') && !e.target.closest('.img-all-close')) {
      modal.classList.remove('open');
      document.body.classList.remove('img-all-open');
    }
  });

  // Wishlist Hero連携
  // WishlistHeroの状態をカスタムボタン＆stickyハートに反映
  (function() {
    const customBtn = document.getElementById('wlh-custom-btn-' + SID + '');
    const circle = customBtn ? customBtn.querySelector('.wlh-custom-circle') : null;
    const textEl = customBtn ? customBtn.querySelector('.wlh-custom-text') : null;

    function syncState(wlhContainer) {
      const isAdded = !!wlhContainer.querySelector('.wishlisthero-product-in-wishlist');
      if (circle) circle.classList.toggle('is-added', isAdded);
      if (textEl) textEl.textContent = isAdded ? 'お気に入りを削除' : 'お気に入りに追加';
      const stickyCircle = document.querySelector('.sticky-wishlist-btn .wlh-custom-circle');
      if (stickyCircle) stickyCircle.classList.toggle('is-added', isAdded);
    }

    const waitForWlh = new MutationObserver(() => {
      const wlhContainer = document.querySelector('#wishlist-hero-product-page-button');
      if (!wlhContainer) return;
      waitForWlh.disconnect();
      syncState(wlhContainer);
      new MutationObserver(() => syncState(wlhContainer)).observe(wlhContainer, {
        attributes: true, attributeFilter: ['class'],
        childList: true, subtree: true
      });
    });
    waitForWlh.observe(document.body, { childList: true, subtree: true });
  })();
});

window.__pdpWhenReady(function() {
  document.querySelectorAll('.product__rec-item').forEach(function(item) {
    item.addEventListener('touchstart', function() { item.classList.add('is-tapped'); }, {passive: true});
    item.addEventListener('touchend', function() { setTimeout(function() { item.classList.remove('is-tapped'); }, 150); }, {passive: true});
    item.addEventListener('touchcancel', function() { item.classList.remove('is-tapped'); }, {passive: true});
  });
});

window.__pdpWhenReady(function() {
  var currentHandle = DATA.handle;

  function buildItem(p, imgSrc, typeLabel, priceText) {
    var a = document.createElement('a');
    a.className = 'product__rec-item';
    a.href = '/products/' + p.handle;
    var badges = '';
    if (!p.available) {
      badges = '<span class="product__rec-badge product__rec-badge--soldout">売り切れ</span>';
    } else if (p.compare_at_price_min && p.compare_at_price_min > p.price_min) {
      badges = '<span class="product__rec-badge product__rec-badge--sale">SALE</span>';
    }
    var badgesHtml = badges ? '<div class="product__rec-badges">' + badges + '</div>' : '';
    var priceHtml = priceText;
    var imgHtml = imgSrc ? '<div class="product__rec-item-img"><img src="' + imgSrc + '" alt="" loading="lazy">' + badgesHtml + '</div>' : '';
    a.innerHTML = imgHtml +
      '<div class="product__rec-item-type">' + typeLabel + '</div>' +
      '<div class="product__rec-item-price">' + priceHtml + '</div>';
    a.addEventListener('touchstart', function() { a.classList.add('is-tapped'); }, {passive: true});
    a.addEventListener('touchend', function() { setTimeout(function() { a.classList.remove('is-tapped'); }, 150); }, {passive: true});
    a.addEventListener('touchcancel', function() { a.classList.remove('is-tapped'); }, {passive: true});
    return a;
  }

  /* ── 最近見たアイテム ── */
  var STORAGE_KEY = 'territory_recent_products';
  var recentSection = document.getElementById('product-recent-' + SID + '');
  var recentList = document.getElementById('recent-list-' + SID + '');

  /* 現在の商品データ（Liquidで事前レンダリング） */
  var currentProduct = {
    handle: DATA.handle,
    title: DATA.title,
    type: DATA.type,
    price: DATA.price,
    compare_at_price: DATA.compareAtPriceMax,
    available: DATA.available,
    image: DATA.featuredImage300
  };

  try {
    var recent = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    /* 旧フォーマット（文字列）との互換性を保ちつつ現在の商品を除外 */
    recent = recent.filter(function(item) {
      var h = typeof item === 'string' ? item : item.handle;
      return h !== currentHandle;
    });
    var toShow = recent.slice(0, 5);

    if (toShow.length && recentSection && recentList) {
      recentSection.style.display = '';
      toShow.forEach(function(item) {
        /* 旧フォーマット（文字列）はスキップ */
        if (typeof item === 'string') return;
        var price = item.price ? '¥' + (item.price / 100).toLocaleString('ja-JP', {maximumFractionDigits:0}) : '';
        recentList.appendChild(buildItem(item, item.image || '', item.title || item.type || item.handle, price));
      });
      /* 表示できたアイテムがなければセクションを隠す */
      if (!recentList.children.length) recentSection.style.display = 'none';
    }

    /* 現在の商品データを履歴の先頭に追加して保存（fetchなし） */
    recent.unshift(currentProduct);
    if (recent.length > 30) recent = recent.slice(0, 30);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
  } catch(e) {}
});

